import { Injectable } from '@angular/core';
import { CommunicationConfigService } from '../communication-config/communication-config.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class DynamicCssService {
  constructor(private CommunicationConfigService: CommunicationConfigService, private http: HttpClient) {}

  getCss() {
    return this.http.get(`${this.CommunicationConfigService.getBackUri()}/api/config/color-of`);
  }
}
